import { DateService } from '@rocheglobal/component-library-dot-com/src/services/date';
import React, { useEffect, useState } from 'react';
import { parseAssetSource, parseDownloadSource } from '../props/asset';
import { Props } from '../types';
import { StringService } from '../../services';

export const RocheDownloadTeaser = ({ blok, slot }: Props): JSX.Element => {
  const [state, setState] = useState({
    formattedDate: '',
  });

  const teaserImage = blok?.teaser_image?.[0];
  const internalAsset = blok?.internal_asset?.filename;
  const externalAsset = blok?.external_asset;
  const publishingDate = blok?.publishing_date;
  const externalAssetLink = `${process.env.GATSBY_CORS_HEADER_API}?url=${externalAsset}`;

  useEffect(() => {
    let isMounted = true;

    const getParsedDate = async (): Promise<void> => {
      const formattedDate = publishingDate && typeof document !== 'undefined'
        ? await DateService.formatDate(publishingDate, 'dateFull')
        : '';

      if (isMounted) {
        setState((prevState) => ({ ...prevState, formattedDate }));
      }
    };

    getParsedDate();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {blok && (
        <roche-teaser
          layout={blok.layout}
          teaser-title={blok.teaser_title}
          teaser-overline={blok.teaser_overline || state.formattedDate}
          teaser-description={StringService.getExtension(
            internalAsset || externalAsset,
          ).toUpperCase()}
          teaser-image={parseAssetSource(teaserImage?.src.filename)}
          teaser-url={parseDownloadSource(internalAsset) || externalAssetLink}
          is-download-link
          loaded={true}
          slot={slot}
        >
          <a
            data-onedatalayer-download-name={StringService.getFileNameWithoutExtension(
              internalAsset || externalAsset,
            )}
            data-onedatalayer-download-format={StringService.getExtension(
              internalAsset || externalAsset,
            )}
            data-onedatalayer-download-url={parseDownloadSource(internalAsset) || externalAssetLink}
            href={parseDownloadSource(internalAsset) || externalAssetLink}
            download
          >
            {blok.teaser_title}
          </a>
        </roche-teaser>
      )}
    </>
  );
};
